<button
  type="button"
  mat-button
  #trigger="matMenuTrigger"
  class="breadcrumb-toolbar-button"
  [matMenuTriggerFor]="menu"
  (menuOpened)="isMenuOpened = trigger.menuOpen"
  (menuClosed)="isMenuOpened = trigger.menuOpen">
  <mat-icon class="breadcrumb-menu" [class]="{ 'breadcrumb-menu-rotated': isMenuOpened }"> navigation </mat-icon>
</button>
<mat-menu #menu="matMenu">
  @for (breadcrumb of breadcrumbs(); track breadcrumb.type + ':' + breadcrumb.label + ':' + breadcrumb.popCount) {
    <span>
      <button type="button" mat-menu-item matTooltipPosition="after" (click)="breadcrumbClicked.emit(breadcrumb)">
        <span>{{ breadcrumb.label }}</span>
      </button>
    </span>
  }

  @if (forms.length > 0) {
    <span>
      <button type="button" mat-menu-item [matMenuTriggerFor]="subMenu" matTooltipPosition="below">
        <span>{{ selectedForm.name }}</span>
      </button>
      <mat-menu #subMenu="matMenu" class="breadcrumb-form-menu">
        @for (form of forms; track form.id) {
          <button type="button" mat-menu-item (click)="onOptionSelected(form)" matTooltipPosition="after">
            <span>{{ form.name }}</span>
          </button>
        }
      </mat-menu>
    </span>
  }
</mat-menu>
